import { Add } from "@mui/icons-material";
import FieldNoteBox from "../boxContainer/fieldNotesBox.component";
import FormActionButton from "../buttons/formActionButton.component";
import FieldNotesFilterSection from "../fieldNotesFilterSection/fieldNotesFilterSection.component";
import { Box, Paper } from "@mui/material";
import { useNavigate } from "react-router";
import { useState } from "react";
import BaseDialog from "../muiDialogs/baseDialog.component";
import { fieldNoteDialogConfig } from "../muiDialogs/config";
import NoteForm from "../forms/noteForm/noteForm.component";
import NoFilterNotesEmptyState from "../emptyStates/NoFilterNotesEmptyState.component";

const FieldNoteContent = ({
  isMobile,
  filteredNotes,
  isFieldPage = false,
  onFiltersChange,
  showEmptyFilterResult,
  fieldId,
}) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleAddNote = () => {
    if (isFieldPage) {
      setOpen(true);
    } else {
      navigate("/fieldNotebook/addNote");
    }
  };
  const handleDialogClose = () => {
    setOpen(false);
  };
  const handleResetFilters = () => {
    setSelectValue("");
    setStartDate(null);
    setEndDate(null);
    setSearchQuery("");
  };

  return (
    <Paper
      sx={{
        paddingY: isMobile ? 1 : 2,
        paddingX: isMobile ? 2 : 4,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: "1 1 auto",
        minHeight: 0,
      }}
      elevation={0}
    >
      <Box
        display="flex"
        width="100%"
        mb={isMobile ? 2 : 5}
        sx={{
          flexDirection: {
            xs: "column",
            md: "column",
            lg: "row",
            xl: "row",
          },
          height: {
            xs: "auto",
            md: "auto",
            lg: "auto",
            xl: "auto",
          },
        }}
        gap={2}
      >
        <FieldNotesFilterSection
          isMobile={isMobile}
          onFiltersChange={onFiltersChange}
          selectValue={selectValue}
          setSelectValue={setSelectValue}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          fieldId={fieldId}
        />
        <FormActionButton
          startIcon={<Add />}
          label="Nuova nota"
          onClick={handleAddNote}
          style={{
            minWidth: "142px",
            width: isMobile ? "100%" : "fit-content",
            height: "40px",
            textTransform: "none",
            borderRadius: "2px",
          }}
        />
      </Box>
      {showEmptyFilterResult ? (
        <NoFilterNotesEmptyState onClick={handleResetFilters} />
      ) : (
        <Box sx={{ flex: "1 1 auto", overflow: "auto", minHeight: 0 }}>
          <FieldNoteBox
            fieldNotesData={filteredNotes}
            isMobile={isMobile}
            showEmptyFilterResult={showEmptyFilterResult}
            isFieldPage={isFieldPage}
          />
        </Box>
      )}
      <BaseDialog
        open={open}
        config={fieldNoteDialogConfig}
        onClose={handleDialogClose}
        title="Aggiungi nota"
        children={
          <NoteForm isFieldPage={isFieldPage} onSuccess={handleDialogClose} />
        }
      />
    </Paper>
  );
};

export default FieldNoteContent;
